var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1732_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.25C12.259 17.25 11.25 16.241 11.25 15V11.25H10.5C10.086 11.25 9.75 10.914 9.75 10.5C9.75 10.086 10.086 9.75 10.5 9.75H11.25C12.077 9.75 12.75 10.423 12.75 11.25V15C12.75 15.414 13.086 15.75 13.5 15.75H14.25C14.664 15.75 15 16.086 15 16.5C15 16.914 14.664 17.25 14.25 17.25H13.5Z",
    fill: "#0088A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.25C12.2463 8.25 12.75 7.74632 12.75 7.125C12.75 6.50368 12.2463 6 11.625 6C11.0037 6 10.5 6.50368 10.5 7.125C10.5 7.74632 11.0037 8.25 11.625 8.25Z",
    fill: "#0088A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12C24 18.617 18.617 24 12 24ZM12 1.5C6.21 1.5 1.5 6.21 1.5 12C1.5 17.79 6.21 22.5 12 22.5C17.79 22.5 22.5 17.79 22.5 12C22.5 6.21 17.79 1.5 12 1.5Z",
    fill: "#0088A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1732_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIButton);
export default __webpack_public_path__ + "static/media/i-button.f1137f6b71e9a7a1287c0e04e75877e6.svg";
export { ForwardRef as ReactComponent };